import React, { useEffect } from "react";
import ReactDOM from "react-dom";

const QueueAlertModal = ({ isOpen, onClose }) => {
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
            document.documentElement.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
            document.documentElement.style.overflow = "";
        }
        return () => {
            document.body.style.overflow = "";
            document.documentElement.style.overflow = "";
        };
    }, [isOpen]);

    if (!isOpen) return null;

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) onClose();
    };

    return ReactDOM.createPortal(
        <div
            onClick={handleBackdropClick}
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 9999,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "24px",
                background: "rgba(0,0,0,0.4)",
            }}
        >
            <div
                style={{
                    background: "#fff",
                    width: "100%",
                    maxWidth: "360px",
                    borderRadius: "28px",
                    border: "0.5px solid rgba(0,0,0,0.1)",
                    padding: "36px 28px 28px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                }}
            >
                {/* Icon */}
                <div
                    style={{
                        width: "72px",
                        height: "72px",
                        borderRadius: "50%",
                        background: "#FAEEDA",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: "20px",
                    }}
                >
                    <svg
                        width="32"
                        height="32"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M12 2L2 19h20L12 2z"
                            fill="#EF9F27"
                            opacity="0.18"
                        />
                        <path
                            d="M12 2L2 19h20L12 2z"
                            stroke="#BA7517"
                            strokeWidth="1.5"
                            strokeLinejoin="round"
                        />
                        <line
                            x1="12"
                            y1="9"
                            x2="12"
                            y2="14"
                            stroke="#BA7517"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                        />
                        <circle cx="12" cy="17" r="0.75" fill="#BA7517" />
                    </svg>
                </div>

                {/* Label */}
                <p
                    style={{
                        fontSize: "11px",
                        fontWeight: 500,
                        letterSpacing: "0.08em",
                        color: "#888",
                        margin: "0 0 8px",
                        textTransform: "uppercase",
                    }}
                >
                    Antrian Aktif
                </p>

                {/* Title */}
                <h2
                    style={{
                        fontSize: "18px",
                        fontWeight: 500,
                        color: "#111",
                        margin: "0 0 10px",
                        lineHeight: 1.3,
                    }}
                >
                    Anda sudah memiliki antrian
                </h2>

                {/* Description */}
                <p
                    style={{
                        fontSize: "13px",
                        color: "#888",
                        lineHeight: 1.6,
                        margin: "0 0 28px",
                    }}
                >
                    Saat ini Anda sudah memiliki antrian yang aktif. Mohon
                    tunggu hingga antrian Anda selesai sebelum mengambil antrian
                    baru.
                </p>

                {/* Buttons */}
                <div
                    style={{
                        width: "100%",
                        borderTop: "0.5px solid rgba(0,0,0,0.1)",
                        paddingTop: "20px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                    }}
                >
                    <button
                        onClick={onClose}
                        style={{
                            width: "100%",
                            padding: "11px 16px",
                            background:
                                "linear-gradient(to right, #06B6D4, #0891B2)",
                            color: "#fff",
                            border: "none",
                            borderRadius: "100px",
                            fontSize: "14px",
                            fontWeight: 500,
                            cursor: "pointer",
                        }}
                    >
                        Oke, saya mengerti
                    </button>
                    <button
                        onClick={onClose}
                        style={{
                            width: "100%",
                            padding: "11px 16px",
                            background: "transparent",
                            color: "#888",
                            border: "0.5px solid rgba(0,0,0,0.2)",
                            borderRadius: "100px",
                            fontSize: "13px",
                            cursor: "pointer",
                        }}
                    >
                        Lihat antrian saya
                    </button>
                </div>
            </div>
        </div>,
        document.body,
    );
};

export default QueueAlertModal;
